
<template>
  <div class="c-micro-notification" @click="activate">
    <span class="c-micro-notification__text" ref="text">
      {{ text }}
    </span>
  </div>
</template>

<script>
import anime from "animejs";
export default {
  data: function() {
    var obj = {
      lock: false
    };
    return obj;
  },
  props: ["text"],
  methods: {
    activate: function() {
      if (this.lock) {
        return;
      }
      this.lock = true;
      var keyframes = [];
      keyframes.push({
        duration: 90,
        translateY: "0px",
        opacity: "1",
        direction: "alternate",
        easing: "easeInOutQuad"
      });
      keyframes.push({
        delay: 900,
        duration: 90,
        translateY: "-4px",
        opacity: "0",
        direction: "alternate",
        easing: "easeInOutQuad"
      });
      anime({
        targets: this.$refs.text,
        keyframes: keyframes,
        complete: () => {
          this.lock = false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.c-micro-notification {
  height: 24px;
  display: flex;
  align-items: center;
  user-select: none;
  &__text {
    pointer-events: none;
    display: inline-block;
    color: $green;
    font-weight: 500;
    font-size: 12px;
    opacity: 0;
    transform: translateY(4px);
  }
}
</style>